import { Button, Container } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import LoadingScreen from "src/components/LoadingScreen";
import useSettings from "src/hooks/useSettings";
import { PATH_DASHBOARD } from "src/routes/paths";
import { getLocationDataApi } from "src/Api/Services/SystemConfiguration";
import LocationTable from "./LocationTable";
import CustomModalComp from "src/components/CustomComponents/CustomModalComp";
import UpdateLocation from "./UpdateLocation";

const LocationComp = () => {
  const { themeStretch } = useSettings();
  const [locationData, setLocationData] = useState([]);
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState("");
  console.log(editData);
  const [loading, setloading] = useState(true);
  const fetchData = async () => {
    try {
      const { data } = await getLocationDataApi();
      let newRes = data.data.length > 0 ? data.data : [];
      setLocationData(newRes || []);
    } catch (error) {
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <Container maxWidth={themeStretch ? false : "xxxl"} spacing={1}>
      <HeaderBreadcrumbs
        heading="Location"
        links={[
          { name: "Dashboard", href: PATH_DASHBOARD.root },
          {
            name: "Add Location",
            href: PATH_DASHBOARD.systemConfig.location,
          },
        ]}
      />

      {locationData.length > 0 && (
        <LocationTable
          data={locationData}
          editClick={(item) => setEditData(item)}
        />
      )}
      <CustomModalComp
        show={editData ? true : false}
        onHide={() => setEditData("")}
        title="Update Location"
        backdrop={true}
      >
        <UpdateLocation
          data={editData}
          fetchData={() => {
            fetchData();
            setEditData("");
          }}
        />
      </CustomModalComp>
    </Container>
  );
};

export default LocationComp;
